import React, { ReactElement, FunctionComponent } from 'react'
import Label from '../Basic'

const BreakingLabel: FunctionComponent = (): ReactElement => {
    return (
        <Label backgroundColor="ORANGE" fontColor="WHITE">
            breaking
        </Label>
    )
}

export default BreakingLabel
